<template>
  <section>
    <Feature :title="$t('RM_PART_NO_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="[$t('CATEGORY'), '', '']">
        <Select style="width: 200px;" v-model="rmCategory" @on-change="onchange()" :placeholder="$t('CHOOSE_ROLE')"
          slot="a">
          <Option v-for="(item, index) in rmCategoryList" :value="item.code" :key="index">
            {{ item.name }}
          </Option>
        </Select>
        <Button type="primary" @click="upload" slot="b">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="download" slot="c">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="dataList" :pageObj="pageObj"
        @changePage="changePage" v-if="isData"></TablePage>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" @on-ok="uploadOk" @on-cancel="uploadCancel" sticky
      :draggable="true" v-model="model" :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="editModal"
      :title="$t('UPDATE')" @on-ok="confirm">
      <FormRow :fieldNameArr="[$t('CATEGORY'), $t('RM_PART_NO'), $t('RM_PART_NO_DESC'), $t('REMARK')]">
        <Select style="width: 200px;" v-model="rmPartNo.rmCategory" :placeholder="$t('CHOOSE_ROLE')" slot="a">
          <Option v-for="(item, index) in rmCategoryList" :value="item.code" :key="index">
            {{ item.name }}
          </Option>
        </Select>
        <Input v-model="rmPartNo.partNo" :maxlength="20" slot="b" />
        <Input v-model="rmPartNo.partNoDesc" slot="c" />
        <Input v-model="rmPartNo.remark" slot="d" />
      </FormRow>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate, ExceptionHandling } from "@/util/common"

export default {
  name: "RmParNoMaintain",
  created() {
    this.search()
  },
  data() {
    return {
      model: false,
      editModal: false,
      rmPartNo: {},
      file: null,
      rmCategory: "RESIN",
      rmCategoryList: [{
        code: 'RESIN',
        name: 'Resin'
      }, {
        code: 'STEEL',
        name: 'Steel'
      }, {
        code: 'CCL',
        name: 'CCL'
      }],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-create",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.edit(params.row)
                },
              },
            })
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_PART_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "partNo",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_PART_NO_DESC')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "partNoDesc",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "remark",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_GROUP_ACCOUNT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "createAcount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENABLED')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          sortable: true,
          align: "center",
          render: (h, params) => {
            return params.row.enabled
              ? h("Icon", {
                props: {
                  type: "md-checkmark-circle",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    params.row.enabled = !params.row.enabled
                    this.setEnalbe(params.row)
                  },
                },
              })
              : h("Icon", {
                props: {
                  type: "md-close-circle",
                  size: 28,
                },
                class: "text-delta-red",
                on: {
                  click: () => {
                    params.row.enabled = !params.row.enabled
                    this.setEnalbe(params.row)
                  },
                },
              })
          },
        }
      ],
      dataList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    create() {
      this.search(true)
    },
    onchange() {
      this.search(true)
    },
    search(init) {
      let vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.dataList = []
      vueInstance.$quotationHttp
        .get("/rmPartNo/find/" + this.rmCategory + "?page=" + vueInstance.pageObj.page + "&size=" + vueInstance.pageObj.pageSize)
        .then((response) => {
          vueInstance.toggleLoading(false)
          if (response.data._embedded) {
            vueInstance.dataList = response.data._embedded.rmPartNoResourceList
            vueInstance.pageObj = {
              "page": response.data.page.number + 1,
              "totalPage": response.data.page.totalPages,
              "totalCount": response.data.page.totalElements,
              "pageSize": response.data.page.size
            }
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    uploadOk() {
      this.file = null
    },
    uploadCancel() {
      this.file = null
    },
    upload() {
      this.model = true
    },
    downloadSample() {
      this.$downloadMasterAttachment(this, 'RmPartNo')
    },
    download() {
      this.$getDownloadExcel(this, "rmPartNo/" + this.rmCategory, "?sort=rmCategory&sort=partNo&sort=partNoDesc")
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      let fd = new FormData()
      fd.append('file', this.file)
      this.toggleLoading(true)
      this.$quotationHttp
        .post("/rmPartNo/uploadExcel", fd)
        .then((response) => {
          this.file = null
          this.model = false
          this.search(true)
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
        })
        .catch((error) => {
          this.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    edit(row) {
      this.editModal = true
      this.rmPartNo = row
    },
    confirm() {
      const vueInstance = this
      if (vueInstance.valid()) {
        update(vueInstance, vueInstance.rmPartNo)
      }
    },
    valid() {
      let errorMessage = ""
      if (!this.rmPartNo.partNo) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('RM_PART_NO') + " <br>"
      }
      if (!this.rmPartNo.partNoDesc) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('RM_PART_NO_DESC') + " <br>"
      }
      if (errorMessage) {
        AlertInfo(this, errorMessage).then(() => {
        })
      }
      return errorMessage == ""
    },
    setEnalbe(data) {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/rmPartNo/enable", JSON.stringify(data))
        .then((response) => {
          this.pageObj.page = this.pageObj.page - 1
          this.search(false)
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function update(vueInstance, data) {
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .post("/rmPartNo/update", JSON.stringify(data))
    .then((response) => {
      vueInstance.pageObj.page = vueInstance.pageObj.page - 1
      vueInstance.search(false)
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}
</script>

<style scoped></style>
